import React from "react";

class DownloadLink extends React.Component {
    render() {
        return (
            <a className={'m-0 text-decoration-none text-dark'} target={'_blank'} href={this.props.src} download={true} >{this.props.children}</a>
        )
    }
}
export default DownloadLink